import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { WorkspaceContext } from "../contexts/WorkspaceContext";
import { AuthContext } from "../contexts/AuthContext";
import Navbar from "../components/Navbar";
import Person from "../components/Person";
import Spinner from "../components/Spinner";
import {
  IoGlobeOutline,
  IoAddCircleOutline,
  IoLogInOutline,
} from "react-icons/io5";
import { HiOutlineLink } from "react-icons/hi2";
import { BsPeople } from "react-icons/bs";
import { ThemeContext } from "../contexts/ThemeContext";
import appLogo from "../assets/img/app_logo.png";

export default function WorkspaceSelectorPage() {
  const navigate = useNavigate();
  const { workspaces, currentWorkspace, selectWorkspace, createWorkspace } =
    useContext(WorkspaceContext);
  const { user } = useContext(AuthContext);
  const { theme } = useContext(ThemeContext);

  const [tab, setTab] = useState("list");

  useEffect(() => {
    if (currentWorkspace) {
      navigate("/", { replace: true });
    }
  }, [currentWorkspace, navigate]);

  const [inviteCode, setInviteCode] = useState("");
  const [nom, setNom] = useState("");
  const [description, setDescription] = useState("");
  const [creating, setCreating] = useState(false);

  const handleSelect = (ws) => {
    selectWorkspace(ws);
    navigate("/", { replace: true });
  };

  const handleJoin = () => {
    const input = inviteCode.trim();
    if (input.length < 3) return;
    const match = input.match(/\/invite\/([a-f0-9]+)/i);
    const token = match ? match[1] : input;
    navigate(`/invite/${token}`);
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!nom.trim()) return;
    setCreating(true);
    await createWorkspace(nom.trim(), description.trim());
    setCreating(false);
    navigate("/", { replace: true });
  };

  return (
    <>
      <Navbar />
      <div className="tyn-content tyn-auth tyn-auth-centered">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-8 col-md-9 col-sm-9">
            <div className="text-center animate__animated animate__infinite animate__pulse">
              <img
                className="tyn-logo taille-du-logo-form my-tyn-logo"
                  src={appLogo}
                alt="Logo_app"
              />
            </div>

            <div className="card border-0">
              <div className="p-4">
                <div className="text-center mb-4">
                  <h3>Bienvenue, {user?.prenom}</h3>
                  <p className="text-muted mb-0">
                    {tab === "list"
                      ? "Choisissez un espace de travail"
                      : "Créez un nouvel espace"}
                  </p>
                </div>

                {/* Onglets */}
                <div className="d-flex mb-4 border-bottom">
                  <button
                    className={`btn btn-sm flex-fill rounded-0 border-0 pb-3 ${
                      tab === "list"
                        ? "text-primary border-bottom border-primary border-2 fw-semibold"
                        : "text-muted"
                    }`}
                    onClick={() => setTab("list")}
                  >
                    <BsPeople className="me-1" />
                    Mes espaces
                  </button>
                  <button
                    className={`btn btn-sm flex-fill rounded-0 border-0 pb-3 ${
                      tab === "create"
                        ? "text-primary border-bottom border-primary border-2 fw-semibold"
                        : "text-muted"
                    }`}
                    onClick={() => setTab("create")}
                  >
                    <IoAddCircleOutline className="me-1" />
                    Créer
                  </button>
                  <button
                    className={`btn btn-sm flex-fill rounded-0 border-0 pb-3 ${
                      tab === "join"
                        ? "text-primary border-bottom border-primary border-2 fw-semibold"
                        : "text-muted"
                    }`}
                    onClick={() => setTab("join")}
                  >
                    <IoLogInOutline className="me-1" />
                    Rejoindre
                  </button>
                </div>

                {/* ── Onglet Liste ── */}
                {tab === "list" && (
                  <>
                    {workspaces.length === 0 ? (
                      <div className="text-center py-4 text-muted">
                        <IoGlobeOutline
                          style={{ fontSize: "2.5rem" }}
                          className="mb-2"
                        />
                        <p>Aucun espace pour le moment</p>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => setTab("create")}
                        >
                          Créer le premier espace
                        </button>
                      </div>
                    ) : (
                      <div className="d-flex flex-column gap-2">
                        {workspaces.map((ws) => (
                          <button
                            key={ws._id}
                            className="btn btn-light border d-flex align-items-center gap-3 p-3 w-100 text-start ws-selector-card"
                            style={{ borderRadius: 12 }}
                            onClick={() => handleSelect(ws)}
                          >
                            <div
                              className="tyn-media tyn-size-md tyn-circle"
                              style={{
                                width: 44,
                                height: 44,
                                flexShrink: 0,
                                overflow: "hidden",
                              }}
                            >
                              {ws.imageUrl ? (
                                <img
                                  src={ws.imageUrl}
                                  alt={ws.nom}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <Person
                                  person={{
                                    image: null,
                                    nom: ws.nom,
                                    prenom: "",
                                    userId: ws._id,
                                    colors: ws.color,
                                  }}
                                />
                              )}
                            </div>
                            <div className="flex-fill">
                              <h6 className="mb-0 fw-semibold">{ws.nom}</h6>
                              {ws.description && (
                                <small className="text-muted">
                                  {ws.description}
                                </small>
                              )}
                            </div>
                            <span className="badge bg-light text-muted text-capitalize">
                              {ws.role === "owner" ? "Propriétaire" : ws.role==="member"?"Membre":ws.role==="guest"?"Invité":ws.role}
                            </span>
                          </button>
                        ))}
                      </div>
                    )}
                  </>
                )}

                {/* ── Onglet Création ── */}
                {tab === "create" && (
                  <>
                    {creating ? (
                      <div className="text-center py-5">
                        <Spinner visibility={creating} />
                        <p className="text-muted mt-2">Création en cours...</p>
                      </div>
                    ) : (
                      <form onSubmit={handleCreate}>
                        <div className="row g-3">
                          <div className="col-12">
                            <div className="form-group">
                              <label className="form-label" htmlFor="ws-name">
                                Nom de l'espace
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="ws-name"
                                  placeholder="Ex: Marketing, RH, Projet Alpha..."
                                  value={nom}
                                  onChange={(e) => setNom(e.target.value)}
                                  autoFocus
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <label className="form-label" htmlFor="ws-desc">
                                Description (optionnelle)
                              </label>
                              <div className="form-control-wrap">
                                <textarea
                                  className="form-control"
                                  id="ws-desc"
                                  rows="3"
                                  placeholder="Décrivez le but de cet espace..."
                                  value={description}
                                  onChange={(e) => setDescription(e.target.value)}
                                  style={{ resize: "none" }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            <button
                              type="submit"
                              className="btn btn-primary w-100"
                              disabled={nom.trim().length < 2}
                            >
                              <IoGlobeOutline className="me-2" />
                              Créer l'espace
                            </button>
                          </div>
                          {workspaces.length > 0 && (
                            <div className="col-12 text-center">
                              <small className="text-muted">
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm p-0"
                                  onClick={() => setTab("list")}
                                >
                                  Retour à la liste
                                </button>
                              </small>
                            </div>
                          )}
                        </div>
                      </form>
                    )}
                  </>
                )}

                {/* ── Onglet Rejoindre ── */}
                {tab === "join" && (
                  <div>
                    <p className="text-muted mb-3">
                      Entrez le code d'invitation reçu pour rejoindre
                      un espace de travail.
                    </p>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="invite-code">
                        Code d'invitation
                      </label>
                      <div className="form-control-wrap position-relative">
                        <span
                          style={{
                            position: "absolute",
                            left: 12,
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 3,
                            color: "#6c757d",
                            display: "flex",
                            fontSize: "1.15rem",
                          }}
                        >
                          <HiOutlineLink />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="invite-code"
                          placeholder="Entrez le code d'invitation..."
                          value={inviteCode}
                          onChange={(e) => setInviteCode(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && inviteCode.trim().length >= 3) handleJoin();
                          }}
                          autoFocus
                          style={{ paddingLeft: "2.2rem" }}
                        />
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-primary w-100"
                      disabled={inviteCode.trim().length < 3}
                      onClick={handleJoin}
                    >
                      <IoLogInOutline className="me-2" />
                      Rejoindre
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
